import { SVGProps } from 'react';

const BellIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 18.333a2.083 2.083 0 0 0 2.083-2.083H7.917A2.083 2.083 0 0 0 10 18.333Zm6.25-4.166v-4.167a6.25 6.25 0 0 0-5-6.104V3.333a1.25 1.25 0 1 0-2.5 0v.563a6.25 6.25 0 0 0-5 6.104v4.167l-1.25 1.25v.417h15v-.417l-1.25-1.25Z"
        fill="#FFA500"
      />
    </svg>
  );
};

export default BellIcon;
